import * as React from 'react';
import { Flex, Heading } from '@chakra-ui/react';
import Layout from '../components/layout';
import FancyImage from '../components/fancy-image';

const HowItWorks = () => {
  return (
    <Layout>
      <Heading textAlign="center" margin="30px 0px">
        Technologies used to develop this website
      </Heading>
      <Flex flexWrap="wrap" justifyContent="center" maxWidth="80vw" margin="0 auto">
        <FancyImage
          title="AWS"
          description="Amazon Web Services, Inc. is a subsidiary of Amazon providing on-demand cloud computing platforms and APIs"
          link="https://aws.amazon.com/"
          imageLink="https://upload.wikimedia.org/wikipedia/commons/thumb/9/93/Amazon_Web_Services_Logo.svg/1200px-Amazon_Web_Services_Logo.svg.png"
        />
        <FancyImage
          title="Gatsby"
          description="Gatsby provides development teams an open source frontend framework for creating rich, optimized websites"
          link="https://www.gatsbyjs.com/"
          imageLink="https://pbs.twimg.com/profile_images/1135999619781939201/HZ-pCQcP_400x400.png"
        />
        <FancyImage
          title="Google Analytics"
          description="Google Analytics is a web analytics service offered by Google that tracks and reports website traffic"
          link="https://analytics.google.com/analytics/web/"
          imageLink="https://neilpatel.com/wp-content/uploads/2017/08/googleanalytics.png"
        />
        <FancyImage
          title="Prism.js"
          description="Prism is a lightweight, extensible syntax highlighter, built with modern web standards in mind"
          link="https://prismjs.com/"
          imageLink="https://pbs.twimg.com/profile_images/2451426554/Screen_Shot_2012-07-31_at_21.57.03__400x400.png"
        />
        <FancyImage
          title="D3.js"
          description="D3.js is a JavaScript library for manipulating documents based on data"
          link="https://d3js.org/"
          imageLink="https://avatars1.githubusercontent.com/u/1562726?s=200&v=4"
        />
        <FancyImage
          title="Chakra UI"
          description="Chakra UI is a simple, modular and accessible component library that gives you the building blocks you need to build your React applications"
          link="https://chakra-ui.com/"
          imageLink="https://pbs.twimg.com/profile_images/1244925541448286208/rzylUjaf_400x400.jpg"
        />
        <FancyImage
          title="GitHub"
          description="GitHub, Inc. is a provider of Internet hosting for software development and version control using Git"
          link="https://github.com/"
          imageLink="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT59FI47FE02xesR8DhmzX56t2ENpAcWXafvw&usqp=CAU"
        />
        <FancyImage
          title="React.js"
          description="React is a free and open-source front-end JavaScript library for building user interfaces based on UI components"
          link="https://reactjs.org/"
          imageLink="https://lh3.googleusercontent.com/isLdXNXSkJKT5CUY-S4ZfK2q_BwrhoNKF2GQVwoo0IEAsOj-CABaJrBCw_K0s9vp03q7ZyGd2a5EfABoBEPPN4LZz_uV2ofS0xCkRYlVjZFB1HpMM0gccvzGGT2v5yTH2f10UhZ6"
        />
      </Flex>
    </Layout>
  );
};

export default HowItWorks;
